import { render, staticRenderFns } from "./InternoNew.vue?vue&type=template&id=df00ae94"
import script from "./InternoNew.vue?vue&type=script&lang=js"
export * from "./InternoNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports